import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component, input,
  ViewEncapsulation
} from '@angular/core';
import { Pv2TrackInfoComponent } from '@splixer/player-ui';

/**
 * Displays the track info - name, artist, album, release date, label
 * Does NOT display album artwork.
 * If you don't want the startedAt date to display, don't pass it!
 */
@Component({
  selector: 'kexp-mini-track-info',
  templateUrl: 'mini-track-info.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class KexpMiniTrackInfoComponent extends Pv2TrackInfoComponent {
  public showAlbum = input(false, {transform: booleanAttribute});

}
